import React, { Fragment } from 'react';
import styles from './Item.module.scss';
import { ItemListConfig, ItemValueType } from '../../../../../../Models';
import {
  SFIcon,
  SFIconButton,
  SFMenu,
  SFMenuItem,
  SFDivider,
  SFStateMandatedLabel
} from 'sfui';
import { getItemSummary } from '../../../../../../Helpers';
import { InteractiveBox } from 'ui-smartforce-settings';
import { useItemView } from './Hooks/useItemView';

export interface ItemProps {
  index: number;
  item: ItemValueType;
  config: ItemListConfig;
  label: string;
  error?: boolean;
  showStateMandated?: boolean;
  onClick: () => void;
  onRemove: (index: number) => void;
  onDuplicate: (index: number) => void;
}

export const Item = ({
  index,
  item,
  label,
  config,
  error = false,
  showStateMandated = false,
  onClick,
  onRemove,
  onDuplicate
}: ItemProps): React.ReactElement<ItemProps> => {
  const {
    isMenuOpen,
    anchorEl,
    onMoreOptionsClick,
    onMenuClose,
    onDuplicateClick,
    onRemoveClick
  } = useItemView({ onDuplicate, onRemove });

  return (
    <Fragment>
      <div className={styles.item}>
        <InteractiveBox className={styles.itemDescription} onClick={onClick}>
          <div className={styles.brief}>
            <div className={styles.label}>
              {showStateMandated && (
                <SFStateMandatedLabel
                  label={`${label} ${index + 1}`}
                  labelClassName={styles.labelText}
                  required={true}
                  missingInformation={error}
                />
              )}
              {!showStateMandated && <span>{`${label} ${index + 1}`}</span>}
            </div>
            <div
              className={styles.summary}
            >{`${getItemSummary(config, item)}`}</div>
          </div>

          <SFIcon className={styles.icon} icon="Right-2" size="24px" />
        </InteractiveBox>
        <SFIconButton
          sfIcon="Other"
          sfSize="medium"
          rotate="right"
          onClick={onMoreOptionsClick}
          aria-label="More Options"
        />
      </div>

      <SFMenu
        MenuListProps={{ className: styles.menu }}
        open={isMenuOpen}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={onMenuClose}
      >
        <SFMenuItem
          className={styles.shareItem}
          onClick={() => onDuplicateClick(index)}
        >
          Duplicate
        </SFMenuItem>

        <SFDivider />

        <SFMenuItem onClick={() => onRemoveClick(index)}>Remove</SFMenuItem>
      </SFMenu>
    </Fragment>
  );
};
